export default "__VITE_ASSET__DmOsGMVb__"